import {FC} from 'react'
import {useParams} from 'react-router-dom'
import {cdrAPI} from '../../../../services/CDRService'

type Props = {
  data: string
}

const ErItemEmployee: FC<Props> = ({data}) => {
  const {appId} = useParams()
  const {data: cdrUsers} = cdrAPI.useGetUsersQuery(appId!)

  const user = cdrUsers?.users.find((i) => i.number === data)

  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex justify-content-start flex-column me-3 text-gray-800'>
        <span className='small text-gray-900'>
          {user?.name ? (
            <span className='text-gray-800'>
              {user.name.length > 27 ? `${user.name.slice(0, 27)}...` : user.name} ({data})
            </span>
          ) : (
            <span className='text-gray-800'>{data}</span>
          )}
        </span>
      </div>
    </div>
  )
}

export {ErItemEmployee}
